import { CASE_TAGS } from '../constants';
import { api } from '../core';

export type CaseCloseResponse = null;

type CaseCloseProps = {
  caseId: string;
  notify_proclaim: boolean;
};

const caseCloseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseClose: builder.query<CaseCloseResponse, CaseCloseProps>({
      query: ({ caseId, notify_proclaim }: CaseCloseProps) => ({
        url: 'case/close',
        method: 'POST',
        body: {
          case_id: caseId,
          notify_proclaim
        }
      }),
      async onQueryStarted({ caseId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate specific case tags for this case
          dispatch(api.util.invalidateTags([...CASE_TAGS.map((tag) => ({ type: tag, id: caseId })), ...CASE_TAGS]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseClose in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseCloseQuery } = caseCloseApi;
